/** UsingQR JSON for Swedish bank app payment QR codes (Bankgiro). */

export const normalizeBankgiroDigits = (bankgiro) =>
  String(bankgiro || '').replace(/\D/g, '');

export const formatBankgiro = (bankgiro) => {
  const digits = normalizeBankgiroDigits(bankgiro);
  if (digits.length === 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  if (digits.length === 8) return `${digits.slice(0, 4)}-${digits.slice(4)}`;
  return String(bankgiro || '').trim();
};

const toYmd = (value) => {
  if (!value) {
    const d = new Date();
    return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
  }
  const raw = String(value).trim();
  if (raw.length >= 10 && raw[4] === '-') return raw.slice(0, 10).replace(/-/g, '');
  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) {
    return `${parsed.getFullYear()}${String(parsed.getMonth() + 1).padStart(2, '0')}${String(parsed.getDate()).padStart(2, '0')}`;
  }
  return toYmd(null);
};

export const buildUsingQrPayload = ({
  accountName,
  companyId,
  bankgiro,
  reference,
  amount,
  invoiceDate,
  dueDate,
}) => {
  const acc = formatBankgiro(bankgiro);
  if (!normalizeBankgiroDigits(acc)) return null;
  const ref = String(reference || '').trim();
  if (!ref) return null;
  const payload = {
    uqr: 1,
    tp: 1,
    nme: String(accountName || 'Butik').trim().slice(0, 70),
    cid: String(companyId || '-').trim().slice(0, 20),
    iref: ref.slice(0, 25),
    idt: toYmd(invoiceDate),
    ddt: toYmd(dueDate || invoiceDate),
    due: Math.round(Number(amount || 0) * 100) / 100,
    pt: 'BG',
    acc,
  };
  return JSON.stringify(payload);
};
